module.exports = __webpack_public_path__ + "static/about-img-c71acfc13e7b4da5dd2cc19c55a2075c.jpg";